import React from 'react'

class Container extends React.Component {
    render() {
        const {children, style} = this.props

        const defaultStyle = {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            height: '100%',
            width: '100%'
        }

        style && Object.keys(style).map((key) => {
            defaultStyle[key] = style[key]
        })

        return (
            <div style={defaultStyle}>
                {children}
            </div>

        )
    }
}

export default Container
